import { render, staticRenderFns } from "./ActionButton.vue?vue&type=template&id=626b5df1&scoped=true"
import script from "./ActionButton.vue?vue&type=script&lang=ts"
export * from "./ActionButton.vue?vue&type=script&lang=ts"
import style0 from "./ActionButton.vue?vue&type=style&index=0&id=626b5df1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "626b5df1",
  null
  
)

export default component.exports